exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer{position:relative}.customer .searchlist-search{position:absolute;top:-50px;right:10px}.customer .searchlist-search .el-form{height:40px}.customer .searchlist-search .searchBtn{width:90px}", ""]);

// exports
